import {
  extractSalary,
  formatCurrency,
  normalizeDate,
} from "../../../../components/common/Converter";
import { findObjectUseCase } from "../../../../usecases/object";
import {
  calculateAmount,
  roundDownAmount,
  toCamelCase,
  _chunkArray,
  _omitKeys,
  _calculateAmountRoundDown,
} from "../helper-payroll/HelperFunction";
import {
  _delSpecificFields,
  _buildPayrollData,
  _getContributions,
  _getCsvData,
  _getCsvDataKeys,
  _getMatchedFields,
} from "./table-object-helper/FormPresenterHelper";
import { v4 as uuidv4, validate } from "uuid";
import { payrollCaseRegistry } from "../payroll-cases/PayrollCasesPage";
import {
  getPipelineHolidaysWithinRange,
  getPipelineSuspensionWithinRange,
} from "../../../../components/common/PipelineQuery";
// import { printComponent } from "nq-component";
// import printComponent from "../../../../printComponent";
import AggregateUseCase from "../../../../usecases/object/AggregateUseCase";
import { PrintPayrollTable } from "../print-payroll/PrintPayrollTable";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";

class FormPayrollPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  get selectedValues() {
    return this.view.props.panelState || {};
  }

  checkCase(caseName) {
    const caseHandler = payrollCaseRegistry[caseName];
    return caseHandler ? caseHandler(this.selectedValues) : false;
  }

  getMatchingCase() {
    for (const caseName in payrollCaseRegistry) {
      if (this.checkCase(caseName)) {
        return caseName;
      }
    }
    return null;
  }

  getCaseListName() {
    const caseMap = {
      isFirstCase: "firstCaseLists",
      isSecondCase: "secondCaseLists",
      isThirdCase: "thirdCaseLists",
      isFourthCase: "fourthCaseLists",
      isFifthCase: "fifthCaseLists",
      isSixthCase: "sixthCaseLists",
      isSeventhCase: "seventhCaseLists",
      isEightCase: "eightCaseLists",
      isTenthCase: "tenthCaseLists",
      isEleventhCase: "eleventhCaseLists",
      isTwelvethCase: "twelveCaseLists",
    };

    const currentCaseKey = Object.keys(caseMap).find((caseKey) =>
      this.checkCase(caseKey)
    );

    return {
      caseLists: caseMap[currentCaseKey],
      cases: currentCaseKey,
    };
  }

  _onPrintPayroll = () => {
    // printComponent(this.view.contractPDF.current);
    const { tableObjects, tableHeaders, tfootObjects, value, signatories } =
      this.view.state;
    const { panelState, otherInfo } = this.view.props;
    const otherData = {
      panelState,
      value,
      signatories,
      otherInfo,
    };
    PrintPayrollTable(tableObjects, tableHeaders, tfootObjects, otherData);
  };

  _getTableData(data, otherCalculations, requestLists) {
    const { panelState } = this.view.props;
    const { payItems } = panelState;

    let secondCaseLists = {};
    if (otherCalculations?.secondCaseLists) {
      secondCaseLists = otherCalculations.secondCaseLists;
    }

    const contributions = requestLists?.contributionListMap ?? {};

    const isSeventh = this.checkCase("isSeventhCase");
    const getPositionTitle = (obj) => obj.position?.position_title || "N/A";

    const params = {
      checkCase: this.checkCase.bind(this),
      otherCalculations,
      isSeventh,
      getPositionTitle,
    };
    const matchedFields = _getMatchedFields(params);
    if (!matchedFields) return [];

    const csvMap = {};
    (panelState?.csvData || []).forEach((entry) => {
      csvMap[entry.agencyEmployeeNo] = entry;
    });

    const contributionsMap = {};
    (contributions || []).forEach((item) => {
      contributionsMap[item.id] = item;
    });

    const _buildRow = (obj) => {
      const secondCase = secondCaseLists?.[obj.id] || {};

      const shouldZeroContributions =
        Number(secondCase.earnedBasic || 0) === 0 &&
        Number(secondCase.earnedPeraAda || 0) === 0;

      const row = {};
      for (const key in matchedFields) {
        const value = matchedFields[key];
        if (typeof value === "function") {
          row[key] = value(obj);
        } else if (obj.hasOwnProperty(value)) {
          row[key] =
            value === "salaryGrade" ? extractSalary(obj[value]) : obj[value];
        } else {
          row[key] = "";
        }
      }
      // Merge CSV data
      const csvEntry = csvMap[obj?.agency?.toString()] || {};

      Object.keys(csvEntry).forEach((key) => {
        if (key !== "agencyEmployeeNo" && key !== "tax") {
          row[key] = csvEntry[key] || "0";
        } else if (key === "tax") {
          const val = csvEntry[key];
          row[key] = val ? Number(val) : 0;
        }
      });
      // Merge contributions
      const contributionEntry = contributionsMap[obj.id] || {};
      const contributionDetails = contributionEntry.contributions || {};

      Object.keys(contributionDetails).forEach((key) => {
        if (shouldZeroContributions) {
          row[key] = 0;
        }
        if (
          this.checkCase("isThirdCase") &&
          (key === "gsisLR" || key === "pagibig" || key === "phic")
        ) {
          row[key] = [0];
        } else if (payItems === "Last" && key === "pagibig") {
          row[key] = 0;
        }
        // else if (payItems === "Initial" && key === "phic") {
        //   row[key] = 0;
        // }
        else if (this.checkCase("isSecondCase") && key === "gsisLR") {
          const { secondCaseLists } = otherCalculations;
          row[key] = secondCaseLists[obj.id]?.gsis;
        } else if (this.checkCase("isSeventhCase") && key === "gsisLR") {
          const { seventhCaseLists } = otherCalculations;
          row[key] = seventhCaseLists[obj.id]?.gsis;
        } else {
          row[key] = contributionDetails[key] || "0";
        }
      });
      return row;
    };

    return data.map(_buildRow);
  }

  async getRequests(deductionLists) {
    const { objects, otherInfo } = this.view.props;
    const contributionArr = deductionLists?.contributions;
    const { contributionType } = deductionLists;

    const groupCases_1 =
      this.checkCase("isFirstCase") ||
      this.checkCase("isSecondCase") ||
      this.checkCase("isThirdCase") ||
      this.checkCase("isFourthCase") ||
      this.checkCase("isSeventhCase") ||
      this.checkCase("isTenthCase");
    const groupCases_2 =
      this.checkCase("isFifthCase") ||
      this.checkCase("isSixthCase") ||
      this.checkCase("isNinthCase");

    const groupCases_3 =
      this.checkCase("isTirteenthCase") || this.checkCase("isFourteenthCase");
    let id = [];
    for (const dataID of objects) {
      id.push(dataID.id);
    }

    let requests = [];
    let taxTable, contributions, allowances, contributionLists, incentives;

    const idChunks = _chunkArray(id, 100);
    if (groupCases_1) {
      requests.push(
        findObjectUseCase().execute("tax-table", {
          keys: ["compensation", "from", "to", "initial", "percent"],
        })
      );
      for (const chunk of idChunks) {
        requests.push(
          findObjectUseCase().execute("contributions", {
            where: {
              empID: { $in: chunk },
            },
          })
        );
        requests.push(
          findObjectUseCase().execute("allowances", {
            where: {
              empID: { $in: chunk },
            },
          })
        );
      }
    } else if (groupCases_2) {
      for (const chunk of idChunks) {
        requests.push(
          findObjectUseCase().execute("allowances", {
            where: { empID: { $in: chunk } },
          })
        );
      }
    } else if (groupCases_3) {
      requests.push(
        findObjectUseCase().execute("incentive", {
          // where: {
          //   id: otherInfo.incentiveId,
          // },
        })
      );
    }

    const results = await Promise.all(requests);

    if (groupCases_1) {
      [taxTable, contributions, allowances] = results;
    } else if (groupCases_2) {
      [allowances] = results;
    } else if (groupCases_3) {
      [incentives] = results;
    }

    let extractedTaxes = [];
    const contributionListMap = [];

    const allowancesByEmpID = allowances?.reduce((result, record) => {
      const empID = record?.empID;
      if (!result[empID]) {
        result[empID] = [];
      }
      result[empID].push(record);
      return result;
    }, {});

    const allowanceLists = {
      allowance: allowancesByEmpID,
    };

    if (groupCases_1) {
      for (let i = 0; i < taxTable.length; i++) {
        const taxItem = taxTable[i];
        extractedTaxes.push({
          compensation: extractSalary(taxItem?.compensation) || 0,
          from: extractSalary(taxItem?.from) || 0,
          to: extractSalary(taxItem?.to) || 0,
          initial: extractSalary(taxItem?.initial) || 0,
          percent: parseFloat(taxItem?.percent.replace(/[^\d.]/g, "")) || 0,
        });
      }

      const contributionName = new Map();
      for (const item of contributionArr) {
        const contributionType = toCamelCase(item.contributionType);
        if (!contributionName.has(item.contributionType)) {
          contributionName.set(contributionType, []);
        }
        contributionName.get(contributionType).push({
          roundUp: item.roundUp,
          roundDown: item.roundDown,
        });
      }

      const contributionMap = new Map();
      for (const item of contributions) {
        if (!contributionMap.has(item.empID)) {
          contributionMap.set(item.empID, {});
        }
        contributionMap.get(item.empID)[toCamelCase(item.contribution)] =
          item.amount;
      }

      let mandatoryFormula = {};

      for (const item of objects) {
        const monthlyRate = extractSalary(item.salaryGrade);
        const contributionsObject = {};

        if (contributionType.length > 0) {
          for (const data of contributionType) {
            const contributionKey = toCamelCase(data);
            const expression = contributionMap.get(item.id)?.[contributionKey];
            mandatoryFormula = contributionMap.get(item.id);

            let value = expression
              ? calculateAmount(expression, monthlyRate)
              : 0;

            if (value !== undefined) {
              const roundingRules = contributionName.get(contributionKey) || [];

              const roundUp = roundingRules.find((rule) => rule.roundUp);
              const roundDown = roundingRules.find((rule) => rule.roundDown);

              const roundDownRule = roundingRules[0]?.roundDown;

              if (roundUp) {
                value = parseFloat(
                  formatCurrency(value.toString()).replace(/,/g, "") || 0
                );
              } else if (roundDownRule) {
                // value = roundDownAmount(value);
                value = _calculateAmountRoundDown(expression, monthlyRate);
              } else {
                value = parseFloat(
                  formatCurrency(value.toString()).replace(/,/g, "") || 0
                );
              }
            }

            contributionsObject[contributionKey] = value;
          }
        }

        contributionListMap.push({
          id: item.id,
          contributions: contributionsObject,
        });
      }

      return {
        extractedTaxes,
        contributionListMap,
        allowanceLists,
        mandatoryFormula,
      };
    } else if (groupCases_2) {
      return { allowanceLists, contributionListMap };
    } else if (groupCases_3) {
      return { incentives, contributionListMap };
    }

    return { taxTable, allowances, contributionLists, contributionListMap };
  }

  async _onSavePayroll() {
    const { panelState, otherInfo } = this.view.props;
    const { payrollPeriod } = panelState;
    const { jobTypeVal, payItemVal, payrollTypeVal, payItems, jobTypeID } =
      panelState;
    const { tableObjects, requestLists, deductionLists } = this.view.state;

    const isJoBackPay = jobTypeVal === "Job Order" && payItems === "Last";
    const isJoInitial = jobTypeVal === "Job Order" && payItems === "Initial";

    const contributionsLists = requestLists?.contributionListMap?.[0] ?? [];
    const contributions = contributionsLists?.contributions ?? {};
    const contributionsArray = Object.keys(contributions || {});
    const contributionsName =
      deductionLists?.contributions?.map((c) => c?.contributionType) || [];
    let incentiveName = [];

    const caseChecker = this.checkCase.bind(this);

    if (caseChecker("isTirteenthCase")) {
      const additionalHeader = deductionLists?.incentives.flatMap((item) =>
        item?.otherAdditionals.map((allowance) => allowance?.name)
      );
      const deductionsHeader = deductionLists?.incentives.flatMap((item) =>
        item?.otherDeductions.map((allowance) => allowance?.name)
      );
      incentiveName.push(...additionalHeader, ...deductionsHeader);
    }

    console.log("incentiveName", incentiveName);
    const omitFields = ["acctNo", "email", "employeeNumber", "fn", "ln", "mn"];

    const joCases = {
      isJoBackPay,
      isJoInitial,
    };

    const collectionName =
      caseChecker("isThirdCase") ||
      caseChecker("isSixthCase") ||
      caseChecker("isTwelvethCase") ||
      caseChecker("isEightCase") ||
      isJoBackPay
        ? "payroll_back_pay"
        : "payroll";

    console.log("collectionName", collectionName);

    const payrollID = uuidv4();

    const payrollList = {
      id: payrollID,
      payrollCode: payrollPeriod?.payrollCode ?? "",
      startDate: payrollPeriod?.periodCovered?.startDate || payrollPeriod?.monthFrom,
      endDate: payrollPeriod?.periodCovered?.endDate || payrollPeriod?.monthTo,
      payrollType: payrollTypeVal,
      jobType: jobTypeVal,
      payItem: payItemVal || payItems,
      contributions: contributionsName,
      deductions: deductionLists?.deductionType ?? [],
      incentives: caseChecker("isTirteenthCase") ? incentiveName : [],
      employmentType: { id: jobTypeID },
      stats: "Pending",
    };

    try {
      const CHUNK_SIZE = 100;
      const employeeChunks = _chunkArray(tableObjects, CHUNK_SIZE);

      for (const chunk of employeeChunks) {
        await Promise.all(
          chunk.map(async (item) => {
            const allContributions = _getContributions(item, contributions);
            const allCsvData = _getCsvData(item, panelState?.csvData);
            const formattedCsvArray = allCsvData
              ? Object.entries(allCsvData).map(
                  ([key, value]) => `${key}:  ${value}`
                )
              : [];

            const csvDataKeys = _getCsvDataKeys(allCsvData);

            const omitTheseKeys = [
              ...omitFields,
              ...contributionsArray,
              ...csvDataKeys,
            ];
            const cleanedItem = _omitKeys(item || {}, omitTheseKeys || []);
            const { id, basic, pera, netofMandatory, taxDue, netPay, ...res } =
              cleanedItem;
            const params = {
              res,
              cleanedItem,
              allContributions,
              formattedCsvArray,
              payrollID,
              id,
              netPay,
              pera,
              netofMandatory,
              taxDue,
              basic,
              caseChecker,
              panelState,
              datePicked: panelState?.datePicked,
              joCases,
            };

            _delSpecificFields(res, caseChecker, joCases);
            const payrollData = _buildPayrollData(params);

            console.log("payrollDatas", payrollData);

            return this.upsertUseCase.execute(collectionName, payrollData);
          })
        );
      }

      await this.upsertUseCase.execute("payroll_list", payrollList);
      this.view.props.closeFloating();
      this.view.props.refetchData();
      this.view.showSuccess("Payroll Successfully Saved");
    } catch (error) {
      console.log(error);
      this.view.showError("Failed to save payroll. Please try again.");
    }
  }

  getAttendanceSummary = async (objects, selectedDate, airportSched, cases) => {
    console.log("objects", objects);
    // console.log("airportSched", airportSched);
    const ids = objects.map((employee) => employee.id);

    const isArrayDate = Array.isArray(selectedDate);
    const dateRanges = Array.isArray(selectedDate)
      ? selectedDate
      : [selectedDate];

    let allEmployeeLogs = [],
      completeLogs = [],
      orConditions = [],
      orConditionsLeave = [],
      orConditionsManual = [],
      allLeaves = [],
      allManualDtr = [];

    for (const range of dateRanges) {
      const start = range?.startDate ? new Date(range.startDate) : null;
      const end = range?.endDate
        ? new Date(new Date(range.endDate).getTime() + 2 * 24 * 60 * 60 * 1000)
        : null;

      if (
        start instanceof Date &&
        !isNaN(start) &&
        end instanceof Date &&
        !isNaN(end)
      ) {
        const validDates = [];
        let dateCursor = new Date(start);

        while (dateCursor < end) {
          const dateStr = new Date(dateCursor).toISOString().split("T")[0];
          validDates.push(dateStr);
          dateCursor.setDate(dateCursor.getDate() + 1);
        }

        const nestedDates = validDates.map((d) => [d]);
        orConditions.push({
          date: {
            $gte: start.toISOString(),
            $lt: end.toISOString(),
          },
        });
        orConditionsLeave.push({
          startdate: { $lte: end.toISOString() },
          enddate: { $gte: start.toISOString() },
        });
        orConditionsManual.push({
          selectDate: { $in: nestedDates },
        });
      }
    }

    const empAssignmentDates = this.getEmployeeAssignmentDates(
      airportSched,
      dateRanges
    );
    const [holidays, suspensions, hol] = await this._dataFetching(
      objects,
      dateRanges
    );

    if (orConditions.length > 0) {
      // Chunk employee IDs to avoid overwhelming the database
      const idChunks = _chunkArray(ids, 100);
      const requests = [];

      // Create requests for each chunk
      for (const chunk of idChunks) {
        requests.push(
          findObjectUseCase().execute("daily_time_record", {
            where: {
              "employee.id": { $in: chunk },
              // timeRecStats: { $in: ["LATE", "UNDERTIME"] },
              $or: orConditions,
            },
          })
        );
        requests.push(
          findObjectUseCase().execute("leave_request", {
            where: {
              "employee.id": { $in: chunk },
              stats: "Approved",
              categoryType: "With Pay",
              $or: orConditionsLeave,
            },
          })
        );
        requests.push(
          findObjectUseCase().execute("manual_dtr", {
            where: {
              "employee.id": { $in: chunk },
              ...(orConditionsManual.length ? { $or: orConditionsManual } : {}),
            },
          })
        );
      }

      // Execute all requests in parallel
      const results = await Promise.all(requests);

      // Combine results from all chunks
      let logs = [];
      let leaves = [];
      let manualDTR = [];

      // Results come in groups of 3 (logs, leaves, manualDTR) for each chunk
      for (let i = 0; i < results.length; i += 3) {
        logs.push(...results[i]);
        leaves.push(...results[i + 1]);
        manualDTR.push(...results[i + 2]);
      }

      const filteredLogs = logs.filter((log) => {
        const logDate = new Date(log.date);
        return !suspensions.some((suspension) => {
          const from = new Date(suspension.from);
          const to = new Date(suspension.to);
          return logDate >= from && logDate <= to;
        });
      });


      const targetStats = new Set(["LATE", "UNDERTIME"]);
      const finalFilteredLogs = filteredLogs.filter((log) =>
        log.timeRecStats?.some((stat) => targetStats.has(stat))
      );

      allEmployeeLogs.push(...filteredLogs);
      allLeaves.push(...leaves);
      completeLogs.push(...logs);
      allManualDtr.push(...manualDTR);
    }

    const filteredLogs1 = allEmployeeLogs.filter((log) => {
      const empId = log.employee?.id;
      const logDate = log.date.split("T")[0];

      return empAssignmentDates[empId]?.has(logDate);
    });

    const logsByEmployeeReg = {};
    for (const log of allEmployeeLogs) {
      const empId = log?.employee?.id;
      if (empId) {
        if (!logsByEmployeeReg[empId]) logsByEmployeeReg[empId] = [];
        logsByEmployeeReg[empId].push(log);
      }
    }

    const logsByEmployeeAirport = {};
    for (const log of filteredLogs1) {
      const empId = log?.employee?.id;
      if (empId) {
        if (!logsByEmployeeAirport[empId]) logsByEmployeeAirport[empId] = [];
        logsByEmployeeAirport[empId].push(log);
      }
    }

    //for holidays
    const holidaySet = new Set(
      holidays.map((h) => new Date(h.date).toDateString())
    );

    //for suspensions
    const suspensionSet = new Set();
    for (const { from, to } of suspensions) {
      let cur = new Date(from);
      const suspensionEnd = new Date(to);
      while (cur <= suspensionEnd) {
        suspensionSet.add(cur.toDateString());
        cur.setDate(cur.getDate() + 1);
      }
    }

    //employee's leaves
    const leaveSetByEmployee = {};
    for (const leave of allLeaves) {
      const empId = leave.employee?.id;
      if (!empId) continue;
      if (!leaveSetByEmployee[empId]) leaveSetByEmployee[empId] = new Set();
      let cur = new Date(leave.startdate);
      const leavesEnd = new Date(leave.enddate);
      while (cur <= leavesEnd) {
        leaveSetByEmployee[empId].add(cur.toDateString());
        cur.setDate(cur.getDate() + 1);
      }
    }

    //employee's manual DTR
    const manualDtrSet = new Set();
    for (const item of allManualDtr) {
      const flatDates = (item?.selectDate || []).flat();
      for (const dateStr of flatDates) {
        manualDtrSet.add(new Date(dateStr).toDateString());
      }
    }

    const manualDtrSetByEmployee = {};
    for (const item of allManualDtr) {
      const empId = item?.employee?.id;
      if (!empId) continue;

      const flatDates = (item?.selectDate || []).flat();

      if (!manualDtrSetByEmployee[empId]) {
        manualDtrSetByEmployee[empId] = new Set();
      }

      for (const dateStr of flatDates) {
        manualDtrSetByEmployee[empId].add(new Date(dateStr).toDateString());
      }
    }

    const getDateRangeSet = (start, end) => {
      const s = new Set();
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        s.add(d.toDateString());
      }
      return s;
    };
    const assignmentPeriodByEmployee = {};
    const airportAbsentSet = {};
    for (const sched of airportSched || []) {
      const start = new Date(sched.startDate);
      const end = new Date(sched.endDate);
      for (const relation of sched.assignRelation || []) {
        const empId = relation.employee?.id;
        if (!empId) continue;
        assignmentPeriodByEmployee[empId] = { start, end };
        airportAbsentSet[empId] = getDateRangeSet(start, end);
      }
    }

    console.log("ALLL EMPLOYEEE LOGS", allEmployeeLogs);

    const schedPatternByEmployee = {};
    for (const employee of objects) {
      const employeeId = employee.id;
      const schedule = employee?.selectedSchedule?.scheduleArray ?? [];
      const scheduleName = schedule[0]?.day || "";

      console.log("SCHEDULEEE", schedule);

      const selectedOption = employee?.selectedSchedule?.selectedOption || "";

      const graveyardMatch = scheduleName.match(
        /^Graveyard (\d+)days Working, (\d+)days off$/
      );
      const regularMatch = scheduleName.match(
        /^Regular (\d+)days Working, (\d+)days off$/
      );
      const plainCycleMatch = scheduleName.match(
        /^(\d+)days Working, (\d+)days off$/
      );

      const alternateMWFMatch = selectedOption === "Alternate (MWF)";
      const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
      const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

      const workingDaysAlt = alternateMWFMatch
        ? ["Monday", "Wednesday", "Friday"]
        : alternateTTHSMatch
        ? ["Tuesday", "Thursday", "Saturday"]
        : [];

      const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;
      const isShiftCycleSchedule = !!matchedSchedule;

      const twoDayGraveyardMatchList = [];
      if (selectedOption === "Graveyard") {
        for (const sched of schedule) {
          const name = sched?.day || "";
          const match = name.match(/^(\w+) - (\w+)$/);
          if (match) {
            twoDayGraveyardMatchList.push({
              match,
              timein: sched.timein,
              timeout: sched.timeout,
              earliestTimeOut: sched.earliestTimeOut,
              lateTimeIn: sched.lateTimeIn,
            });
          }
        }
      }
      const isTwoDayGraveyard = twoDayGraveyardMatchList.length > 0;

      if (isShiftCycleSchedule) {
        schedPatternByEmployee[employeeId] = { matchedSchedule };
      } else if (isTwoDayGraveyard) {
        schedPatternByEmployee[employeeId] = { twoDayGraveyardMatchList };
      } else if (isAlternateSchedule) {
        schedPatternByEmployee[employeeId] = { workingDaysAlt };
      } else {
        schedPatternByEmployee[employeeId] = { selectedOption: schedule };
      }
    }

    console.log("schedPatternByEmployee", schedPatternByEmployee);

    const params = {
      objects,
      dateRanges,
      completeLogs,
      logsByEmployee: logsByEmployeeReg,
      manualDtrSet,
      leaveSetByEmployee,
      manualDtrSetByEmployee,
      holidaySet,
      suspensions,
      suspensionSet,
      schedPatternByEmployee,
      airportAbsentSet,
      isArrayDate,
      cases,
    };

    const { logsByEmployee, ...restParams } = params;
    const paramsAirport = {
      ...restParams,
      logsByEmployee: logsByEmployeeAirport,
      assignmentPeriodByEmployee,
    };

    const { minsResult, absentDateByEmployee, halfDateByEmployee } =
      this._getMinutesDeducted(params, "isnotForAirport");

    console.log("halfDateByEmployee", halfDateByEmployee);
    console.log("absentDateByEmployee", absentDateByEmployee);

    const daysResult = await this._getDaysDeducted(
      params,
      absentDateByEmployee,
      halfDateByEmployee
    );

    console.log("daysResult", daysResult);

    const regularResults = this._combineAttendanceResults(
      minsResult,
      daysResult
    );

    const resultMinsForAirport = this._getMinutesDeducted(
      paramsAirport,
      "isForAirport"
    );
    const resultDaysforAirport = await this._getDaysDeducted(
      paramsAirport,
      absentDateByEmployee,
      halfDateByEmployee,
      resultMinsForAirport.absentByEmployeeAirport
    );

    const airportResults = this._combineAttendanceResults(
      resultMinsForAirport?.minsResult,
      resultDaysforAirport
    );

    return {
      regular: regularResults,
      airport: airportResults,
      absentDateByEmployee,
      halfDateByEmployee,
    };
  };

  _dataFetching = async (employee, dateRange) => {
    const aggregateUseCase = new AggregateUseCase();
    return await Promise.all([
      aggregateUseCase.execute(
        "holidays",
        getPipelineHolidaysWithinRange(employee, dateRange)
      ),
      aggregateUseCase.execute(
        "suspension",
        getPipelineSuspensionWithinRange(employee, dateRange)
      ),
    ]);
  };

  _combineAttendanceResults = (minsArr, daysArr) => {
    const daysMap = Object.fromEntries(daysArr.map((d) => [d.employeeId, d]));
    return minsArr.map((m) => ({
      employeeId: m.employeeId,
      totalDeductedMins: m.totalDeductedMins,
      totalHalfDays: m.totalHalfDays,
      totalAbsences: daysMap[m.employeeId]?.totalAbsences ?? 0,
      totalWorkingDays: daysMap[m.employeeId]?.totalWorkingDays ?? 0,
    }));
  };

  getEmployeeAssignmentDates(airportSched, dateRanges) {
    const air = airportSched || [];
    const empAssignmentDates = {};
    for (const sched of air) {
      const start = new Date(sched.startDate);
      const end = new Date(sched.endDate);
      for (const relation of sched.assignRelation || []) {
        const empId = relation.employee?.id;
        if (!empId) continue;
        if (!empAssignmentDates[empId]) empAssignmentDates[empId] = new Set();
        let d = new Date(start);
        while (d <= end) {
          empAssignmentDates[empId].add(d.toISOString().split("T")[0]);
          d.setDate(d.getDate() + 1);
        }
      }
    }
    return empAssignmentDates;
  }

  _getMinutesDeducted = (params, type) => {
    const {
      objects,
      logsByEmployee,
      dateRanges,
      schedPatternByEmployee,
      isArrayDate,
      suspensions,
      holidaySet,
      suspensionSet,
      manualDtrSet,
      manualDtrSetByEmployee,
      leaveSetByEmployee,
      airportAbsentSet,
      cases,
    } = params;

    const cases1 = "isFifthCase";

    const result = [];
    const absentDateByEmployee = {};
    const halfDateByEmployee = {};
    const absentByEmployeeAirport = {};

    const toDateOnly = (d) => {
      const date = new Date(d);
      date.setHours(0, 0, 0, 0);
      return date;
    };

    const extractLogDays = (logs, days) => {
      return logs?.filter((log) => {
        const logDate = new Date(log.date);
        const logDay = logDate.toLocaleString("en-US", { weekday: "long" });
        return days.includes(logDay);
      });
    };

    const processLog = ({
      log,
      airportDutyByEmployee,
      manualDtrOfEmployee,
      employeeId,
      logsByDate,
      logsByDateEven,
      logsByDateOdd,
      evenToISO,
      newSched,
      schedPattern1,
      startingDate,
      selectedOption,
      twentyFourSeven,
      matchedLog_1,
      matchedLog_2,
      cases1,
    }) => {
      // console.log("log", log);
      // console.log("matchedLog_2", matchedLog_2);
      if (!log?.date)
        return {
          mins: 0,
          halfDays: 0,
          isAbsent: false,
          isHalfDay: false,
          logDate: null,
        };
      const logDate = normalizeDate(new Date(log.date));
      const params = {
        log,
        logsByDate,
        logsByDateEven,
        logsByDateOdd,
        evenToISO,
        employeeId,
        holidaySet,
        suspensionSet,
        manualDtrSet,
        leaveSetByEmployee,
        suspensions,
        airportDutyByEmployee,
        manualDtrOfEmployee,
        schedPattern: schedPattern1,
        twentyFourSeven,
        matchedLog_1,
        ...(matchedLog_2 && { matchedLog_2 }),
        schedule: newSched,
        startingDate,
        cases: cases1,
        type,
        selectedOption,
      };

      // Deducted minutes
      const deducted = this._getLogMinsDeducted(params);
      // Half day
      const halfDay = this._getLogHalfday(params);

      console.log("deducted", deducted);
      console.log("LOG", log);

      return {
        mins: deducted?.mins ?? 0,
        isAbsent: deducted.isAbsent,
        halfDays: halfDay?.halfDays ?? 0,
        isNextDay: deducted.isNextDay,
        isHalfDayForDay_2: halfDay.isHalfDayForDay_2,
        isHalfDay: halfDay.isHalfDay,
        logDate: logDate,
      };
    };
    const formatDate = (d) => new Date(d).toISOString().split("T")[0];
    function* getIndices(i) {
      for (let idx = 0; idx <= i; idx++) {
        if (idx % 2 === 0) {
          yield idx; // yields each even number
        }
      }
    }

    const getIndixes = (i) => {
      if (i % 2 === 0) {
        return i;
      }
    };

    for (const employee of objects) {
      const employeeId = employee.id;
      const selectedOption = employee?.selectedSchedule?.selectedOption ?? "";
      const schedule = employee?.selectedSchedule?.scheduleArray ?? [];
      const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");
      const schedPattern = schedPatternByEmployee?.[employeeId] || {};
      let logs = logsByEmployee[employeeId] || [];
      let firstDay = [];
      let secondDay = [];
      if (schedPattern.twoDayGraveyardMatchList) {
        for (const { match } of schedPattern.twoDayGraveyardMatchList) {
          const [_, day1, day2] = match;
          firstDay.push(day1);
          secondDay.push(day2);
        }
      }

      const firstDayLogs = extractLogDays(logs, firstDay);
      const secondDayLogs = extractLogDays(logs, secondDay);

      const firstDaylogsById = firstDayLogs.reduce((acc, log) => {
        if (log.id) {
          acc[log.id] = log;
        }
        return acc;
      }, {});
      const secondDaylogsById = secondDayLogs.reduce((acc, log) => {
        if (log.id) {
          acc[log.id] = log;
        }
        return acc;
      }, {});

      const sortedLogs = [...logs].sort(
        (a, b) => new Date(a?.date) - new Date(b?.date)
      );
      const lastDate = new Date(sortedLogs[sortedLogs.length - 1]?.date);
      const lastDateOnly = toDateOnly(lastDate);
      logs = logs.filter((log) => {
        const logDate = toDateOnly(log.date);

        if (logDate.getTime() === lastDateOnly.getTime()) {
          return isGraveyard || selectedOption === "Graveyard";
        }

        return logDate < lastDateOnly;
      });

      const startingDate = new Date(employee?.selectedSchedule?.startingDate);
      const airportDutyByEmployee = airportAbsentSet?.[employeeId] || new Set();
      const manualDtrOfEmployee =
        manualDtrSetByEmployee?.[employeeId] || new Set();
      const twentyFourSeven = ["12", "9"].some((prefix) =>
        employee?.twentyFourSeven?.startsWith(prefix)
      );

      // Group logs by date for graveyard
      const logsByDate = {};
      const logsByDateEven = {};
      const logsByDateOdd = {};

      if (isGraveyard || selectedOption === "Graveyard") {
        logs.forEach((l, index) => {
          const key = new Date(l.date).toISOString().split("T")[0];
          const dayKey = new Date(l.date).toLocaleString("en-US", {
            weekday: "long",
          });

          // store all logs
          if (!logsByDate[key]) logsByDate[key] = [];
          logsByDate[key].push(l);

          if (index % 2 === 1) {
            if (!logsByDateEven[key]) logsByDateEven[key] = [];
            logsByDateEven[key].push(l);
          }
          if (index % 2 === 0) {
            if (!logsByDateOdd[key]) logsByDateOdd[key] = [];
            logsByDateOdd[key].push(l);
          }
        });
      }

      let totalDeductedMins = isArrayDate
        ? Array(dateRanges.length).fill(0)
        : 0;
      let totalHalfDays = isArrayDate ? Array(dateRanges.length).fill(0) : 0;
      absentDateByEmployee[employeeId] = new Set();
      halfDateByEmployee[employeeId] = new Set();
      absentByEmployeeAirport[employeeId] = new Set();

      if (isArrayDate) {
        for (let i = 0; i < logs.length; i++) {
          let evenIdx = 0;
          let oddLog = {};

          console.log("II", i);

          const idx = getIndixes(i);

          // for (const even of getIndices(i)) {
          //   evenIdx = even;
          //   console.log("EVENNN", even);
          //   oddLog = logs[even];
          // }
          // const ind = getIndices(i);

          // console.log("ind", ind);

          // console.log("aeen", seen);
          // console.log("isIndexExist", isIndexExist);

          const log = logs[i];

          const dateOfLogs = new Date(log?.date);
          const evenToISO = new Date(dateOfLogs).toISOString().split("T")[0];

          const logsForFirstDay = logsByDateEven[evenToISO]?.[0];

          // console.log("evenLogs", evenLogs);
          const schedPattern1 = this.parseSchedPatternFromLog(log);
          const newSched = log?.schedule?.scheduleArray ?? [];
          const dateLog = new Date(log?.date);

          const lookUpFirstDay = firstDaylogsById[log?.id];
          const lookUpSecondDay = secondDaylogsById[log?.id];
          // console.log("lookUpSecondDay", lookUpSecondDay);

          const matchedLog_1 = firstDayLogs.find(
            (dayLog) => dayLog.id === log.id
          );

          const matchedLog_2 = secondDayLogs.find(
            (dayLog) => dayLog.id === log.id
          );

          let logResult = null;

          const matchedLog = matchedLog_1 && matchedLog_2;

          if (selectedOption === "Graveyard") {
            if (matchedLog_1) {
              // console.log("matchedLog_1", matchedLog_1);
              const params = {
                log,
                airportDutyByEmployee,
                manualDtrOfEmployee,
                employeeId,
                logsByDate,
                logsByDateEven,
                logsByDateOdd,
                evenToISO,
                newSched,
                schedPattern1,
                startingDate,
                selectedOption,
                twentyFourSeven,
                ...(matchedLog_1 && { matchedLog_1 }),
                // ...(matchedLog_2 && { matchedLog_2 }),
                cases1,
              };

              logResult = processLog(params);
            }
            if (matchedLog_2) {
              // console.log("matchedLog_1", matchedLog_1);
              const params = {
                log,
                airportDutyByEmployee,
                manualDtrOfEmployee,
                employeeId,
                logsByDate,
                logsByDateEven,
                logsByDateOdd,
                evenToISO,
                newSched,
                schedPattern1,
                startingDate,
                selectedOption,
                twentyFourSeven,
                matchedLog_2,
                cases1,
              };

              logResult = processLog(params);
            }
          } else {
            const params = {
              log,
              airportDutyByEmployee,
              manualDtrOfEmployee,
              employeeId,
              logsByDate,
              logsByDateEven,
              logsByDateOdd,
              evenToISO,
              newSched,
              schedPattern1,
              startingDate,
              selectedOption,
              twentyFourSeven,
              matchedLog_2: [],
              cases1,
            };
            logResult = processLog(params);
          }

          if (!logResult || !logResult.logDate) continue;

          const {
            mins,
            isAbsent,
            halfDays,
            isHalfDay,
            logDate,
            isNextDay,
            isHalfDayForDay_2,
          } = logResult;

          for (let i = 0; i < dateRanges.length; i++) {
            const range = dateRanges[i];
            const start = new Date(range.startDate);
            const end = new Date(range.endDate);
            if (logDate >= start && logDate <= end) {
              if (isAbsent)
                absentDateByEmployee[employeeId].add(logDate.toDateString());

              if (isAbsent && type === "isForAirport")
                absentByEmployeeAirport[employeeId].add(logDate.toDateString());

              if (isNextDay) {
                const nextDay = new Date(logDate);
                nextDay.setDate(nextDay.getDate() + 1);
                absentDateByEmployee[employeeId].add(nextDay.toDateString());

                if (type === "isForAirport") {
                  absentByEmployeeAirport[employeeId].add(
                    nextDay.toDateString()
                  );
                }
              }

              totalDeductedMins[i] += mins;

              if (isHalfDay)
                halfDateByEmployee[employeeId].add(logDate.toDateString());

              if (isHalfDayForDay_2) {
                const nextDay = new Date(logDate);
                nextDay.setDate(nextDay.getDate() + 1);
                halfDateByEmployee[employeeId].add(nextDay.toDateString());
              }

              totalHalfDays[i] += halfDays;
              break;
            }
          }
        }
      } else {
        for (const log of logs) {
          const schedPattern1 = this.parseSchedPatternFromLog(log);

          const newSched = log?.schedule?.scheduleArray ?? [];
          const {
            mins,
            isAbsent,
            halfDays,
            isHalfDay,
            logDate,
            isNextDay,
            isHalfDayForDay_2,
          } = processLog(
            log,
            airportDutyByEmployee,
            manualDtrOfEmployee,
            employeeId,
            logsByDate,
            logsByDateEven,
            logsByDateOdd,
            newSched,
            schedPattern1,
            startingDate,
            selectedOption,
            twentyFourSeven,
            firstDayLogs,
            secondDayLogs,
            cases1
          );
          if (!logDate) continue;
          if (isAbsent)
            absentDateByEmployee[employeeId].add(logDate.toDateString());
          if (isAbsent && type === "isForAirport")
            absentByEmployeeAirport[employeeId].add(logDate.toDateString());
          if (isNextDay) {
            const nextDay = new Date(logDate);
            nextDay.setDate(nextDay.getDate() + 1);
            absentDateByEmployee[employeeId].add(nextDay.toDateString());

            if (type === "isForAirport") {
              absentByEmployeeAirport[employeeId].add(nextDay.toDateString());
            }
          }
          totalDeductedMins += mins;
          if (isHalfDay)
            halfDateByEmployee[employeeId].add(logDate.toDateString());
          if (isHalfDayForDay_2) {
            const nextDay = new Date(logDate);
            nextDay.setDate(nextDay.getDate() + 1);
            halfDateByEmployee[employeeId].add(nextDay.toDateString());
          }
          totalHalfDays += halfDays;
        }
      }
      result.push({
        employeeId,
        totalDeductedMins,
        totalHalfDays,
      });
    }

    return {
      minsResult: result,
      absentDateByEmployee,
      halfDateByEmployee,
      absentByEmployeeAirport,
    };
  };

  _getLogMinsDeducted = ({
    log,
    logsByDate,
    logsByDateEven,
    logsByDateOdd,
    evenToISO,
    employeeId,
    holidaySet,
    suspensionSet,
    manualDtrSet,
    leaveSetByEmployee,
    suspensions,
    schedPattern,
    twentyFourSeven,
    matchedLog_1,
    matchedLog_2,
    airportDutyByEmployee,
    manualDtrOfEmployee,
    schedule,
    startingDate,
    cases,
    type,
    selectedOption,
  }) => {
    const keys = Object.keys(logsByDateEven);

    // console.log("LEYS", keys);
    // console.log("keys", keys);
    if (Object.keys(log).length === 0) return 0;
    const logDate = new Date(log?.date);
    const dateFirstDay = new Date(matchedLog_1?.date);
    const logDateConverted = new Date(log.date).toDateString();
    const dayName = this._getDayName(logDate);

    const isSpecialCase = [
      "isThirdCase",
      "isSecondCase",
      "isFifthCase",
      "isSixthCase",
      "isSeventhCase",
    ].includes(cases);

    if (
      (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
      manualDtrOfEmployee.has(logDateConverted) ||
      (type !== "isForAirport" &&
        airportDutyByEmployee.has(logDateConverted)) ||
      leaveSetByEmployee[employeeId]?.has(logDateConverted)
    ) {
      return { mins: 0, isAbsent: false };
    }

    // Shift Cycle Schedule
    if (schedPattern.matchedSchedule && startingDate) {
      const [_, work, off] = schedPattern.matchedSchedule.map(Number);

      const cycleLength = work + off;
      const daysSinceStartIn = Math.floor(
        (logDate - startingDate) / (1000 * 60 * 60 * 24)
      );

      if (daysSinceStartIn < 0) return 0;
      const cycleDayIn =
        ((daysSinceStartIn % cycleLength) + cycleLength) % cycleLength;
      // if (cycleDay >= work) return 0;

      const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");

      if (!isGraveyard && cycleDayIn >= work) {
        return 0;
      }

      if (isGraveyard && cycleDayIn > work) {
        return 0;
      }
      const isSpecialCase = [
        "isThirdCase",
        "isSecondCase",
        "isFifthCase",
        "isSixthCase",
        "isSeventhCase",
      ].includes(cases);
      let rawTimeIn = "--:--";
      let rawTimeOut = "--:--";

      if (isGraveyard) {
        rawTimeIn = log?.timePmIn;

        const currentDate = new Date(log.date);
        const nextDate = new Date(currentDate);
        nextDate.setDate(currentDate.getDate() + 1);
        const nextKey = nextDate.toISOString().split("T")[0];

        const nextLog = logsByDate[nextKey];
        const timePmOut = log?.timeOut;
        const nextDayAmOut = nextLog?.[0]?.timeAmOut;
        rawTimeOut =
          timePmOut && timePmOut !== "--:--"
            ? timePmOut
            : nextDayAmOut && nextDayAmOut !== "--:--"
            ? nextDayAmOut
            : "--:--";
      } else {
        rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
        rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;
      }

      const actualTimeInMin = this._toMinutes(rawTimeIn);
      const actualTimeOutMin = this._toMinutes(rawTimeOut);

      const schedTimeInMin = this._toMinutes(
        isSpecialCase
          ? schedule[0]?.lateTimeIn || schedule[0]?.timein
          : schedule[0]?.timein
      );

      let schedTimeOutMin = this._toMinutes(
        isSpecialCase
          ? schedule[0]?.earliestTimeOut || schedule[0]?.timeout
          : schedule[0]?.timeout
      );

      const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);

      if (schedTimeOutMin < actualTimeOutMin) {
        schedTimeOutMin += 1440;
      }

      let rawUndertime = 0;
      if (actualTimeOutMin > 0) {
        rawUndertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);
      }

      const overlapIn = this._getSuspensionOverlapMins(
        suspensions,
        log.date,
        schedTimeInMin,
        actualTimeInMin
      );

      const overlapOut = this._getSuspensionOverlapMins(
        suspensions,
        log.date,
        actualTimeOutMin,
        schedTimeOutMin
      );

      const late = Math.max(rawLate - overlapIn, 0);
      const undertime = Math.max(rawUndertime - overlapOut, 0);

      const totalMins = late + undertime;

      const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
      const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
      const noIn = !hasIn;
      const noOut = !hasOut;

      const nextDate = new Date(logDate);
      nextDate.setDate(logDate.getDate() + 1);
      const nextKey = nextDate.toISOString().split("T")[0];
      const nextLog = logsByDate?.[nextKey]?.[0];

      const hasGraveIn = log?.timePmIn && log.timePmIn !== "--:--";
      const hasGraveOut =
        log?.timeOut && log.timeOut !== "--:--"
          ? true
          : nextLog?.timeAmOut && nextLog.timeAmOut !== "--:--";

      const noGraveIn = !hasGraveIn;
      const noGraveOut = !hasGraveOut;

      const params = {
        late,
        undertime,
        cases,
        log,
        isGraveyard,
        logsByDate,
      };

      if (
        ![
          "isFifthCase",
          "isSixthCase",
          "isFourthCase",
          "isTwelvethCase",
          "isEightCase",
        ].includes(cases) &&
        // For normal schedule
        ((!isGraveyard &&
          ((hasIn && noOut && late <= 180) ||
            (hasOut && noIn && undertime <= 120))) ||
          // For graveyard shift
          (isGraveyard &&
            ((hasGraveIn && noGraveOut && late <= 180) ||
              (hasGraveOut && noGraveIn && undertime <= 120))))
      ) {
        return { mins: 0, isAbsent: false };
      }

      if (isGraveyard) {
        if (cycleDayIn >= work) {
          return { mins: 0, isAbsent: false };
        }
      }

      if (this.shouldSkipLogForCase(params, "forAbsent")) {
        return { mins: 0, isAbsent: true };
      }

      if (["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)) {
        if (totalMins > 60) return { mins: 0, isAbsent: true };
        if (totalMins > 45) return { mins: 60, isAbsent: false };
        if (totalMins > 30) return { mins: 45, isAbsent: false };
        if (totalMins > 15) return { mins: 30, isAbsent: false };
        if (totalMins > 0) return { mins: 15, isAbsent: false };
        return { mins: 0, isAbsent: false };
      }

      return { mins: totalMins, isAbsent: false };
    }

    if (schedPattern.twoDayGraveyardMatchList) {
      for (const {
        match,
        timein,
        timeout,
        lateTimeIn,
        earliestTimeOut,
      } of schedPattern.twoDayGraveyardMatchList) {
        const [_, day1, day2] = match;

        if (dayName === day1) {
          // Calculate late for day1
          const nextDate = new Date(logDate);
          nextDate.setDate(logDate.getDate() + 1);
          const nextKey = nextDate.toISOString().split("T")[0];
          const nextLog = logsByDate?.[nextKey]?.[0];

          const rawTimeAmIn = log?.timeIn;
          const rawTimePmIn =
            log?.timePmIn !== "--:--" ? log?.timePmIn : nextLog?.timeIn;
          const dayScheduleAm = schedule.find((s) => s?.day === dayName);
          const daySchedulePm = schedule.find(
            (s) => s?.day?.includes(dayName) && s.day.includes("-")
          );

          console.log("daySchedulePm", daySchedulePm);
          const rawTimePmOut = log?.timeOut;
          const rawTimeAmOut = nextLog?.timeAmOut;

          const schedTimeInAmMin = this._toMinutes(
            isSpecialCase
              ? dayScheduleAm?.lateTimeIn || dayScheduleAm?.timein
              : dayScheduleAm?.timein
          );
          const schedTimeInPmMin = this._toMinutes(
            isSpecialCase
              ? daySchedulePm?.lateTimeIn || daySchedulePm?.timein
              : daySchedulePm?.timein
          );
          const schedTimeOutPmMin = this._toMinutes(
            isSpecialCase
              ? dayScheduleAm?.earliestTimeOut || dayScheduleAm?.timeout
              : dayScheduleAm?.timeout
          );
          const schedTimeOutAmMin = this._toMinutes(
            isSpecialCase
              ? daySchedulePm?.earliestTimeOut || daySchedulePm?.timeout
              : daySchedulePm?.timeout
          );

          const timeInAmMin = this._toMinutes(rawTimeAmIn);
          const timeInPmMin = this._toMinutes(rawTimePmIn);
          const timeOutPmMin = this._toMinutes(rawTimePmOut);
          const timeOutAmMin = this._toMinutes(rawTimeAmOut);

          const late = Math.max(timeInAmMin - schedTimeInAmMin, 0);
          let undertimeForDay_1 = 0;
          let undertimeForDay_2 = 0;
          // let latePmforDay_1 = 0;
          if (timeOutPmMin > 0) {
            undertimeForDay_1 = Math.max(schedTimeOutPmMin - timeOutPmMin, 0);
          } else {
            undertimeForDay_1 = 0;
          }

          if (timeOutAmMin > 0) {
            undertimeForDay_2 = Math.max(schedTimeOutAmMin - timeOutAmMin, 0);
          } else {
            undertimeForDay_2 = 0;
          }

          const latePmforDay_1 = this._calcLate(timeInPmMin, schedTimeInPmMin);

          const totalLateUTforDay_1 = late + undertimeForDay_1;
          const totalLateUTforDay_2 = latePmforDay_1 + undertimeForDay_2;

          // console.log("log", log);
          // console.log("totalLateUTforDay_1", totalLateUTforDay_1);
          // console.log("totalLateUTforDay_2", totalLateUTforDay_2);

          const totalLateUt = totalLateUTforDay_1 + totalLateUTforDay_2;

          const hasAmIn = rawTimeAmIn !== "--:--";
          const hasPmIn = rawTimePmIn !== "--:--";
          const hasPmOut = rawTimePmOut !== "--:--";
          const hasAmOut = rawTimeAmOut !== "--:--";
          const noAmIn = !hasAmIn;
          const noPmIn = !hasPmIn;
          const noPmOut = !hasPmOut;
          const noAmOut = !hasAmOut;

          const logCheck = {
            hasAmIn,
            hasPmIn,
            hasPmOut,
            hasAmOut,
            noAmIn,
            noPmIn,
            noPmOut,
            noAmOut,
          };

          const params = {
            late,
            latePmforDay_1,
            undertimeForDay_1,
            undertimeForDay_2,
            totalLateUTforDay_1,
            totalLateUTforDay_2,
            cases,
            log,
            logsByDate,
            selectedOption,
            logCheck,
          };

          const skipResult = this.shouldSkipLogForCase(params, "forAbsent");
          const isAbsent = skipResult?.includes?.("isAbsent") ?? false;
          const isNextDay = skipResult?.includes?.("isNextDay") ?? false;

          // console.log("isNextDay", isNextDay);
          // console.log("LOG", log);

          // console.log("skipResult", skipResult);

          const day1Result = (() => {
            const isBracketed = [
              "isFourthCase",
              "isTwelvethCase",
              "isEightCase",
            ].includes(cases);

            if (isBracketed) {
              let isAbsentFlag = false;
              let isNextDayFlag = false;
              let bracket1 = 0;
              let bracket2 = 0;

              // Brackets for Day 1
              if (totalLateUTforDay_1 > 60) {
                isAbsentFlag = true;
              } else if (totalLateUTforDay_1 > 45) {
                bracket1 = 60;
              } else if (totalLateUTforDay_1 > 30) {
                bracket1 = 45;
              } else if (totalLateUTforDay_1 > 15) {
                bracket1 = 30;
              } else if (totalLateUTforDay_1 > 0) {
                bracket1 = 15;
              }

              console.log("bracket1", bracket1);

              // Brackets for Day 2
              if (totalLateUTforDay_2 > 60) {
                isNextDayFlag = true;
              } else if (totalLateUTforDay_2 > 45) {
                bracket2 = 60;
              } else if (totalLateUTforDay_2 > 30) {
                bracket2 = 45;
              } else if (totalLateUTforDay_2 > 15) {
                bracket2 = 30;
              } else if (totalLateUTforDay_2 > 0) {
                bracket2 = 15;
              }

              // If either is over 60, mins should be 0
              if (isAbsentFlag || isNextDayFlag) {
                return {
                  mins: 0,
                  isAbsent: isAbsentFlag,
                  isNextDay: isNextDayFlag,
                };
              }

              // Otherwise use the higher of the two bracket values
              const finalMins = Math.max(bracket1, bracket2);

              return {
                mins: finalMins,
                isAbsent: false,
                isNextDay: false,
              };
            }

            // Default fallback if not in bracketed case
            return {
              mins: totalLateUTforDay_1,
              isAbsent: false,
              isNextDay: false,
            };
          })();

          const totalMins =
            day1Result.mins + (day1Result.isNextDay ? 0 : totalLateUTforDay_2);

          console.log("day1Result", day1Result);
          console.log("totalLateUTforDay_2", totalLateUTforDay_2);

          return {
            mins: totalMins,
            isAbsent: day1Result.isAbsent,
            isNextDay: day1Result.isNextDay,
          };
        }
      }
    }
    // Alternate Schedule
    if (schedPattern.workingDaysAlt) {
      if (!schedPattern.workingDaysAlt.includes(dayName)) return 0;
      const actualTimeInMin = this._toMinutes(log?.timeIn);
      const actualTimeOutMin = this._toMinutes(log?.timeOut);
      const schedTimeInMin = this._toMinutes(schedule[0]?.timein);
      const schedTimeOutMin = this._toMinutes(schedule[0]?.timeout);
      const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
      const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);
      return late + undertime;
    }
    // Default: Regular Schedule
    const daySchedule = schedule.find((s) => s?.day === dayName);
    if (!daySchedule) return { mins: 0, isAbsent: false };

    const rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
    const rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;
    const rawlateTimeIn = isSpecialCase
      ? daySchedule?.lateTimeIn || daySchedule?.timein
      : daySchedule?.timein;

    const rawLateTimeOut = isSpecialCase
      ? daySchedule?.earliestTimeOut || daySchedule?.timeout
      : daySchedule?.timeout;

    const actualTimeInMin = this._toMinutes(rawTimeIn);
    const actualTimeOutMin = this._toMinutes(rawTimeOut);
    const schedTimeInMin = this._toMinutes(rawlateTimeIn);
    const schedTimeOutMin = this._toMinutes(rawLateTimeOut);
    const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);
    const rawUndertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

    const overlapIn = this._getSuspensionOverlapMins(
      suspensions,
      log.date,
      schedTimeInMin,
      actualTimeInMin
    );

    const overlapOut = this._getSuspensionOverlapMins(
      suspensions,
      log.date,
      actualTimeOutMin,
      schedTimeOutMin
    );

    const late = Math.max(rawLate - overlapIn, 0);
    const undertime = Math.max(rawUndertime - overlapOut, 0);
    const totalMins = late + undertime;

    const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
    const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
    const noIn = !hasIn;
    const noOut = !hasOut;

    const params = {
      late,
      undertime,
      cases,
      log,
    };

    if (
      ![
        "isFifthCase",
        "isSixthCase",
        "isFourthCase",
        "isTwelvethCase",
        "isEightCase",
      ].includes(cases) &&
      ((hasIn && noOut && late <= 180) || (hasOut && noIn && undertime <= 120))
    ) {
      return { mins: 0, isAbsent: false };
    }

    if (this.shouldSkipLogForCase(params, "forAbsent")) {
      return { mins: 0, isAbsent: true };
    }

    if (["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases)) {
      if (totalMins > 60) return { mins: 0, isAbsent: true };
      if (totalMins > 45) return { mins: 60, isAbsent: false };
      if (totalMins > 30) return { mins: 45, isAbsent: false };
      if (totalMins > 15) return { mins: 30, isAbsent: false };
      if (totalMins > 0) return { mins: 15, isAbsent: false };
      return { mins: 0, isAbsent: false };
    }

    return { mins: totalMins, isAbsent: false };
  };
  _getLogHalfday = ({
    log,
    logsByDate,
    employeeId,
    holidaySet,
    suspensionSet,
    manualDtrSet,
    leaveSetByEmployee,
    manualDtrOfEmployee,
    schedPattern,
    twentyFourSeven,
    schedule,
    startingDate,
    suspensions,
    cases,
    selectedOption,
  }) => {
    if (Object.keys(log).length === 0) return 0;
    const logDate = new Date(log?.date);
    const logDateConverted = new Date(log.date).toDateString();
    const dayName = this._getDayName(logDate);

    const isSpecialCase = [
      "isThirdCase",
      "isSecondCase",
      "isFifthCase",
      "isSixthCase",
      "isSeventhCase",
    ].includes(cases);

    const _getDateOnly = (dateTimeStr) => {
      if (!dateTimeStr) return null;
      const [datePart] = dateTimeStr.split(" at ");
      return new Date(datePart);
    };

    const suspension = (suspensions || []).find((sus) => {
      if (!sus.dateFrom || !sus.dateTo) return false;
      const susFromDate = _getDateOnly(sus.dateFrom);
      const susToDate = _getDateOnly(sus.dateTo);
      const logDay = new Date(logDate.toDateString());
      return (
        susFromDate && susToDate && logDay >= susFromDate && logDay <= susToDate
      );
    });

    const _isOutBeforeSuspension = (outTime, susStart) => {
      if (!outTime || outTime === "--:--" || !susStart) return true;
      const [h, m] = outTime.split(":").map(Number);
      const outDate = new Date(susStart);
      outDate.setHours(h, m, 0, 0);
      return outDate < susStart;
    };

    const _getSuspensionStart = (suspension) => {
      if (!suspension || !suspension.dateFrom) return null;
      return this._parseSuspensionDate(suspension.dateFrom);
    };

    // Shift Cycle Schedule
    if (schedPattern.matchedSchedule && startingDate) {
      const [_, work, off] = schedPattern.matchedSchedule.map(Number);
      const cycleLength = work + off;
      const daysSinceStartIn = Math.floor(
        (logDate - startingDate) / (1000 * 60 * 60 * 24)
      );
      if (daysSinceStartIn < 0) return 0;
      const cycleDayIn =
        ((daysSinceStartIn % cycleLength) + cycleLength) % cycleLength;
      // if (cycleDay >= work) return 0;

      const isGraveyard = schedule[0]?.day?.startsWith("Graveyard");

      if (!isGraveyard && cycleDayIn >= work) {
        return 0;
      }

      if (isGraveyard && cycleDayIn > work) {
        return 0;
      }

      let rawTimeIn = "--:--";
      let rawTimeOut = "--:--";

      if (isGraveyard) {
        rawTimeIn = log?.timePmIn;

        const currentDate = new Date(log.date);
        const nextDate = new Date(currentDate);
        nextDate.setDate(currentDate.getDate() + 1);
        const nextKey = nextDate.toISOString().split("T")[0];

        const nextLog = logsByDate[nextKey];
        const timePmOut = log?.timeOut;
        const nextDayAmOut = nextLog?.[0]?.timeAmOut;
        rawTimeOut =
          timePmOut && timePmOut !== "--:--"
            ? timePmOut
            : nextDayAmOut && nextDayAmOut !== "--:--"
            ? nextDayAmOut
            : "--:--";
      } else {
        rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
        rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;
      }

      const actualTimeInMin = this._toMinutes(rawTimeIn);
      const actualTimeOutMin = this._toMinutes(rawTimeOut);

      const schedTimeInMin = this._toMinutes(
        isSpecialCase
          ? schedule[0]?.lateTimeIn || schedule[0]?.timein
          : schedule[0]?.timein
      );

      let schedTimeOutMin = this._toMinutes(
        isSpecialCase
          ? schedule[0]?.earliestTimeOut || schedule[0]?.timeout
          : schedule[0]?.timeout
      );

      const rawLate = Math.max(actualTimeInMin - schedTimeInMin, 0);

      if (schedTimeOutMin < actualTimeOutMin) {
        schedTimeOutMin += 1440;
      }

      let rawUndertime = 0;
      if (actualTimeOutMin > 0) {
        rawUndertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);
      }
      const overlapIn = this._getSuspensionOverlapMins(
        suspensions,
        log.date,
        schedTimeInMin,
        actualTimeInMin
      );

      const overlapOut = this._getSuspensionOverlapMins(
        suspensions,
        log.date,
        actualTimeOutMin,
        schedTimeOutMin
      );

      const late = Math.max(rawLate - overlapIn, 0);
      const undertime = Math.max(rawUndertime - overlapOut, 0);

      const params = {
        cases,
        log,
        late,
        undertime,
        schedPattern,
        logsByDate,
        isGraveyard,
      };

      if (
        (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
        (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
        manualDtrOfEmployee.has(logDateConverted) ||
        leaveSetByEmployee[employeeId]?.has(logDateConverted)
      ) {
        return { halfDays: 0, isHalfDay: false };
      }

      if (this.shouldSkipLogForCase(params, "forHalfDay")) {
        return { halfDays: 1, isHalfDay: true };
      }

      return { halfDays: 0, isHalfDay: false };
    }
    // Two Day Graveyard
    if (schedPattern.twoDayGraveyardMatchList) {
      for (const {
        match,
        timein,
        timeout,
        lateTimeIn,
        earliestTimeOut,
      } of schedPattern.twoDayGraveyardMatchList) {
        const [_, day1, day2] = match;
        if (dayName === day1) {
          // Calculate late for day1
          const nextDate = new Date(logDate);
          nextDate.setDate(logDate.getDate() + 1);
          const nextKey = nextDate.toISOString().split("T")[0];
          const nextLog = logsByDate?.[nextKey]?.[0];

          const rawTimeAmIn = log?.timeIn;
          const rawTimePmIn =
            log?.timePmIn !== "--:--" ? log?.timePmIn : nextLog?.timeIn;
          const dayScheduleAm = schedule.find((s) => s?.day === dayName);
          const daySchedulePm = schedule.find(
            (s) => s?.day?.includes(dayName) && s.day.includes("-")
          );
          const rawTimePmOut = log?.timeOut;
          const rawTimeAmOut = nextLog?.timeAmOut;

          const schedTimeInAmMin = this._toMinutes(
            isSpecialCase
              ? dayScheduleAm?.lateTimeIn || dayScheduleAm?.timein
              : dayScheduleAm?.timein
          );
          const schedTimeInPmMin = this._toMinutes(
            isSpecialCase
              ? daySchedulePm?.lateTimeIn || daySchedulePm?.timein
              : daySchedulePm?.timein
          );
          const schedTimeOutPmMin = this._toMinutes(
            isSpecialCase
              ? dayScheduleAm?.earliestTimeOut || dayScheduleAm?.timeout
              : dayScheduleAm?.timeout
          );
          const schedTimeOutAmMin = this._toMinutes(
            isSpecialCase
              ? daySchedulePm?.earliestTimeOut || daySchedulePm?.timeout
              : daySchedulePm?.timeout
          );

          const timeInAmMin = this._toMinutes(rawTimeAmIn);
          const timeInPmMin = this._toMinutes(rawTimePmIn);
          const timeOutPmMin = this._toMinutes(rawTimePmOut);
          const timeOutAmMin = this._toMinutes(rawTimeAmOut);

          const late = Math.max(timeInAmMin - schedTimeInAmMin, 0);
          let undertimeForDay_1 = 0;
          let undertimeForDay_2 = 0;

          if (timeOutPmMin > 0) {
            undertimeForDay_1 = Math.max(schedTimeOutPmMin - timeOutPmMin, 0);
          } else {
            undertimeForDay_1 = 0;
          }

          if (timeOutAmMin > 0) {
            undertimeForDay_2 = Math.max(schedTimeOutAmMin - timeOutAmMin, 0);
          } else {
            undertimeForDay_2 = 0;
          }

          const latePmforDay_1 = this._calcLate(timeInPmMin, schedTimeInPmMin);

          const totalLateUTforDay_1 = late + undertimeForDay_1;
          const totalLateUTforDay_2 = latePmforDay_1 + undertimeForDay_2;

          // console.log("log", log);

          let undertime = 0;

          const totalLateUt = late + undertime;

          const hasAmIn = rawTimeAmIn !== "--:--";
          const hasPmIn = rawTimePmIn !== "--:--";
          const hasPmOut = rawTimePmOut !== "--:--";
          const hasAmOut = rawTimeAmOut !== "--:--";
          const noAmIn = !hasAmIn;
          const noPmIn = !hasPmIn;
          const noPmOut = !hasPmOut;
          const noAmOut = !hasAmOut;

          const logCheck = {
            hasAmIn,
            hasPmIn,
            hasPmOut,
            hasAmOut,
            noAmIn,
            noPmIn,
            noPmOut,
            noAmOut,
          };

          const params = {
            late,
            latePmforDay_1,
            undertimeForDay_1,
            undertimeForDay_2,
            totalLateUTforDay_1,
            totalLateUTforDay_2,
            cases,
            log,
            logsByDate,
            selectedOption,
            logCheck,
          };

          if (
            (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
            (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
            manualDtrSet.has(logDateConverted) ||
            leaveSetByEmployee[employeeId]?.has(logDateConverted)
          ) {
            return { halfDays: 0, isHalfDay: false, isHalfDayForDay_2: false };
          }

          // if (this.shouldSkipLogForCase(params, "forHalfDay")) {
          //   return { halfDays: 1, isHalfDay: true };
          // }

          const skipResult = this.shouldSkipLogForCase(params, "forHalfDay");

          if (skipResult === "isHalfDayforDay_1") {
            return { halfDays: 1, isHalfDay: true, isHalfDayForDay_2: false };
          }

          if (skipResult === "isHalfDayforDay_2") {
            return { halfDays: 1, isHalfDayForDay_2: true, isHalfDay: false };
          }

          return { halfDays: 0, isHalfDay: false, isHalfDayForDay_2: false };
        }
      }
    }
    // Alternate Schedule
    if (schedPattern.workingDaysAlt) {
      if (!schedPattern.workingDaysAlt.includes(dayName)) return 0;
      const hasIn = log?.timeIn && log.timeIn !== "--:--";
      const noOut = !log?.timeOut || log.timeOut === "--:--";
      if (suspension && hasIn) {
        const susStart = _getSuspensionStart(suspension);
        if (noOut) return 1;
        if (_isOutBeforeSuspension(log.timeOut, susStart)) return 1;
        return 0;
      }
      return hasIn && noOut ? 1 : 0;
    }
    // Default: Regular Schedule
    const daySchedule = schedule.find((s) => s?.day === dayName);
    if (!daySchedule) return 0;
    const rawTimeIn = log?.timeIn !== "--:--" ? log?.timeIn : log?.timePmIn;
    const rawTimeOut = log?.timeOut !== "--:--" ? log?.timeOut : log?.timeAmOut;

    const rawlateTimeIn = isSpecialCase
      ? daySchedule?.lateTimeIn || daySchedule?.timein
      : daySchedule?.timein;

    const rawLateTimeOut = isSpecialCase
      ? daySchedule?.earliestTimeOut || daySchedule?.timeout
      : daySchedule?.timeout;

    const actualTimeInMin = this._toMinutes(rawTimeIn);
    const actualTimeOutMin = this._toMinutes(rawTimeOut);
    const schedTimeInMin = this._toMinutes(rawlateTimeIn);
    const schedTimeOutMin = this._toMinutes(rawLateTimeOut);
    const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
    const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

    const params = {
      cases,
      log,
      late,
      undertime,
      schedPattern,
    };

    if (
      (!twentyFourSeven && holidaySet.has(logDateConverted)) ||
      (!twentyFourSeven && suspensionSet.has(logDateConverted)) ||
      manualDtrSet.has(logDateConverted) ||
      leaveSetByEmployee[employeeId]?.has(logDateConverted)
    ) {
      return { halfDays: 0, isHalfDay: false };
    }

    if (this.shouldSkipLogForCase(params, "forHalfDay")) {
      return { halfDays: 1, isHalfDay: true };
    }

    return { halfDays: 0, isHalfDay: false };
  };

  _parseSuspensionDate = (dateStr) => {
    if (!dateStr) return null;
    const [datePart, timePart] = dateStr.split(" at ");
    if (!datePart || !timePart) return null;
    const combined = `${datePart} ${timePart}`;
    return new Date(combined);
  };

  _getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { weekday: "long" });
  };
  _toMinutes = (timeStr, isTimeOut = false) => {
    if (timeStr === "--:--") return 0;

    if (typeof timeStr !== "string" || !timeStr.includes(":")) return 0;

    const [hour, minute] = timeStr.split(":").map(Number);
    let total = hour * 60 + minute;
    // if (!isTimeOut && total < 300) {
    //   return total + 1440;
    // }

    // if (!isTimeOut && hour === 0 && minute === 0) {
    //   return 720;
    // }

    if (!isTimeOut && total < 60) {
      return total + 1440;
    }

    return total;
  };

  _getDaysDeducted = async (
    params,
    absentDateByEmployee,
    halfDateByEmployee,
    absentByEmployeeAirport
  ) => {
    const {
      objects,
      dateRanges,
      completeLogs,
      manualDtrSet,
      leaveSetByEmployee,
      holidaySet,
      suspensionSet,
      schedPatternByEmployee,
      manualDtrSetByEmployee,
      airportAbsentSet,
      isArrayDate,
      assignmentPeriodByEmployee,
    } = params;

    console.log("date ranges", dateRanges);

    //employee's Logs
    const storedLogs = {};
    for (const log of completeLogs) {
      const empId = log?.employee?.id;

      if (empId) {
        if (!storedLogs[empId]) {
          storedLogs[empId] = [];
        }
        storedLogs[empId].push(log);
      }
    }

    let result = [];
    for (const employee of objects) {
      const employeeId = employee.id;

      if (
        assignmentPeriodByEmployee &&
        !assignmentPeriodByEmployee[employeeId]
      ) {
        result.push({
          employeeId,
          totalAbsences: isArrayDate ? Array(dateRanges.length).fill(0) : 0,
          totalWorkingDays: isArrayDate ? Array(dateRanges.length).fill(0) : 0,
        });
        continue;
      }

      const startingDate = new Date(employee?.selectedSchedule?.startingDate);
      const logs = storedLogs[employeeId] || [];
      const schedPattern = schedPatternByEmployee?.[employeeId] || {};
      const dateOfAbsent = absentDateByEmployee[employeeId];
      const dateOfAbsentAirport = absentByEmployeeAirport?.[employeeId];
      const manualDtrOfEmployee =
        manualDtrSetByEmployee?.[employeeId] || new Set();
      const twentyFourSeven = ["12", "9"].some((prefix) =>
        employee?.twentyFourSeven?.startsWith(prefix)
      );

      const groupLogsByDynamicSchedule = (logs = [], dateRanges = []) => {
        if (!logs.length && !dateRanges.length) return {};

        // 🧩 Sort logs chronologically
        logs.sort((a, b) => new Date(a.date) - new Date(b.date));

        const formatDate = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const result = {};

        // ✅ Determine final selection start/end (handle unordered dateRanges)
        let rangeStart, rangeEnd;

        if (dateRanges.length) {
          // 🧠 Sort the dateRanges by startDate
          const sortedRanges = [...dateRanges].sort(
            (a, b) => new Date(a.startDate) - new Date(b.startDate)
          );

          const firstStart = new Date(sortedRanges[0].startDate);
          const lastEnd = new Date(
            sortedRanges[sortedRanges.length - 1].endDate
          );
          const today = new Date();

          // Cap lastEnd to today if it exceeds current date
          rangeStart = firstStart;
          rangeEnd = lastEnd > today ? today : lastEnd;
        } else {
          // fallback to logs only
          rangeStart = new Date(logs[0].date);
          rangeEnd = new Date(logs[logs.length - 1].date);
        }

        // ✅ Filter logs within the date range
        const filteredLogs = logs.filter((log) => {
          const logDate = new Date(log.date);
          return logDate >= rangeStart && logDate <= rangeEnd;
        });

        if (!filteredLogs.length) return {};

        // ✅ Group by schedule pattern (your original logic)
        let currentGroupStart = filteredLogs[0].date;
        let prevParsed = this.parseSchedPatternFromLog(filteredLogs[0]) || {};
        let prevKey = Object.keys(prevParsed)[0];
        let prevValue = JSON.stringify(prevParsed[prevKey] || []);
        let currentGroupLogs = [filteredLogs[0]];
        const tempGroups = [];

        for (let i = 1; i < filteredLogs.length; i++) {
          const currentLog = filteredLogs[i];
          const parsed = this.parseSchedPatternFromLog(currentLog) || {};
          const currentKey = Object.keys(parsed)[0];
          const currentValue = JSON.stringify(parsed[currentKey] || []);

          const isSameSchedule =
            currentKey === prevKey && currentValue === prevValue;

          if (!isSameSchedule) {
            tempGroups.push({
              start: currentGroupStart,
              end: filteredLogs[i - 1].date,
              parsed: prevParsed,
              logs: currentGroupLogs,
            });
            currentGroupStart = currentLog.date;
            prevParsed = parsed;
            prevKey = currentKey;
            prevValue = currentValue;
            currentGroupLogs = [currentLog];
          } else {
            currentGroupLogs.push(currentLog);
          }
        }

        // push last group
        tempGroups.push({
          start: currentGroupStart,
          end: filteredLogs[filteredLogs.length - 1].date,
          parsed: prevParsed,
          logs: currentGroupLogs,
        });

        // ✅ Extend first & last groups to cover full selected range
        if (tempGroups.length) {
          tempGroups[0].start = rangeStart;
          tempGroups[tempGroups.length - 1].end = rangeEnd;
        }

        // ✅ Build final result
        for (const group of tempGroups) {
          const validStartingDates = group.logs
            .map((log) => log.schedule?.startingDate)
            .filter(Boolean)
            .sort();

          const startingDate = validStartingDates[0];
          const rangeKey = `${formatDate(group.start)} - ${formatDate(
            group.end
          )}`;
          result[rangeKey] = {
            ...group.parsed,
            ...(startingDate && { startingDate }),
          };
        }

        return result;
      };

      const groupLogsSched = groupLogsByDynamicSchedule(logs, dateRanges);

      const logSet = new Set();
      logs.forEach((log) => {
        const logDate = new Date(log.date).toDateString();
        logSet.add(logDate);
      });

      if (dateOfAbsent) {
        for (const dateStr of dateOfAbsent) {
          logSet.delete(dateStr);
        }
      }

      if (dateOfAbsentAirport instanceof Set) {
        for (const date of dateOfAbsentAirport) {
          logSet.delete(date);
        }
      }

      let totalAbsences = isArrayDate ? [] : 0;
      let totalWorkingDays = isArrayDate ? [] : 0;
      const dateOfAbsences = {};

      for (const range of dateRanges) {
        let start = new Date(range?.startDate);
        let end = new Date(range?.endDate);

        const airportSched = assignmentPeriodByEmployee?.[employeeId];
        if (airportSched) {
          if (start < airportSched.start) start = new Date(airportSched.start);
          if (end > airportSched.end) end = new Date(airportSched.end);
        }

        // const schedStart = normalizeDate(startingDate);

        // if (start < schedStart) start = schedStart;

        const allWorkingDates = this._getWorkingDaysList(
          start,
          end,
          schedPattern,
          groupLogsSched
        );

        console.log("start", start);
        console.log("end", end);

        console.log("groupLogsSched", groupLogsSched);

        console.log("ACTUALLL WORKING DATESSSss", allWorkingDates);

        const actualWorkingDays = allWorkingDates.filter((dateStr) => {
          const skipSuspension = twentyFourSeven || !suspensionSet.has(dateStr);
          return (
            // !holidaySet.has(dateStr) &&

            !logSet.has(dateStr) &&
            !leaveSetByEmployee[employeeId]?.has(dateStr) &&
            !manualDtrOfEmployee.has(dateStr)
            // !airportDutyByEmployee.has(dateStr)
          );
        });

        console.log("actualWorkingDays", actualWorkingDays);

        if (isArrayDate) {
          totalAbsences.push(actualWorkingDays.length);
          totalWorkingDays.push(allWorkingDates.length);

          if (!dateOfAbsences[employeeId]) {
            dateOfAbsences[employeeId] = new Set();
          }
          actualWorkingDays.forEach((d) => dateOfAbsences[employeeId].add(d));
        } else {
          totalAbsences += actualWorkingDays.length;
          totalWorkingDays = allWorkingDates.length;

          if (!dateOfAbsences[employeeId]) {
            dateOfAbsences[employeeId] = new Set();
          }
          actualWorkingDays.forEach((d) => dateOfAbsences[employeeId].add(d));
        }
      }

      if (isArrayDate) {
        totalAbsences = totalAbsences.map((val) => Math.min(val, 22));
      } else {
        totalAbsences = Math.min(totalAbsences, 22);
      }

      result.push({
        employeeId,
        totalAbsences,
        totalWorkingDays,
        dateOfAbsences,
      });
    }

    return result;
  };

  shouldSkipLogForCase = (
    {
      late,
      undertime,
      latePmforDay_1,
      undertimeForDay_1,
      undertimeForDay_2,
      totalLateUTforDay_1,
      totalLateUTforDay_2,
      cases,
      log,
      schedPattern,
      isGraveyard,
      logsByDate,
      selectedOption,
      logCheck,
    },
    type
  ) => {
    const hasIn = log?.timeIn !== "--:--" || log?.timePmIn !== "--:--";
    const hasOut = log?.timeOut !== "--:--" || log?.timeAmOut !== "--:--";
    const noIn = !hasIn;
    const noOut = !hasOut;
    const totalLateUT = late + undertime;

    const _graveyardLogStatus = () => {
      const logDate = new Date(log.date);
      const nextDate = new Date(logDate);
      nextDate.setDate(logDate.getDate() + 1);
      const nextKey = nextDate.toISOString().split("T")[0];
      const nextLog = logsByDate?.[nextKey]?.[0];

      const hasGraveIn = log?.timePmIn && log.timePmIn !== "--:--";
      const hasGraveOut =
        log?.timeOut && log.timeOut !== "--:--"
          ? true
          : nextLog?.timeAmOut && nextLog.timeAmOut !== "--:--";

      return {
        hasGraveIn,
        hasGraveOut,
        noGraveIn: !hasGraveIn,
        noGraveOut: !hasGraveOut,
      };
    };

    // Case rules configuration
    const absentRules = {
      isBasic:
        type === "forAbsent" &&
        ["isThirdCase", "isSecondCase", "isSeventhCase"].includes(cases),
      isAP:
        type === "forAbsent" &&
        ["isFourthCase", "isTwelvethCase", "isEightCase"].includes(cases),
      isJO: ["isFifthCase", "isSixthCase"].includes(cases),
    };

    // Absent: Basic
    if (absentRules.isBasic) {
      if (!isGraveyard && selectedOption !== "Graveyard") {
        if (
          (noIn && noOut) ||
          totalLateUT > 240 ||
          (hasIn && noOut && late > 180) ||
          (noIn && hasOut && undertime > 120)
        )
          return true;
      } else if (selectedOption === "Graveyard") {
        const {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        } = logCheck;

        // console.log("noPmIn", noPmIn);
        // console.log("hasAmOut", hasAmOut);
        // console.log("late", late);

        if (
          (hasAmIn && noPmOut && late > 180) ||
          (noAmIn && hasPmOut && undertimeForDay_1 > 120) ||
          totalLateUTforDay_1 > 240 ||
          (noAmIn && noPmOut)
        ) {
          return "isAbsent";
        } else if (
          (hasPmIn && noAmOut && latePmforDay_1 > 180) ||
          (noPmIn && hasAmOut && undertimeForDay_2 > 120) ||
          totalLateUTforDay_2 > 240 ||
          (noPmIn && noAmOut)
        ) {
          return "isNextDay";
        }
        return false;
      }
      // else if (selectedOption === "Graveyard") {
      //   const { hasAmIn, hasGraveOut, noAMIn, noGraveOut, hasPmOut, dayName } =
      //     logCheck;

      //   const isValidBoolean = (val) => typeof val === "boolean";
      //   const sam = isValidBoolean(hasAmIn);
      //   const isValidNumber = (val) => Number.isFinite(val);

      //   if (isValidBoolean(hasAmIn)) {
      //     console.log("hasGraveOut", hasGraveOut);
      //     if (hasAmIn) {
      //       return "isAbsentForFirstDay";
      //     }
      //   }

      //   return false;
      // }
      else {
        const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
          _graveyardLogStatus();
        if (
          (hasGraveIn && noGraveOut && late > 180) ||
          (hasGraveOut && noGraveIn && undertime > 120) ||
          totalLateUT > 240 ||
          (noGraveIn && noGraveOut)
        )
          return true;
        return false;
      }
    }

    // Absent: AP
    if (absentRules.isAP) {
      if (!isGraveyard && selectedOption !== "Graveyard") {
        if (
          late > 61 ||
          undertime > 61 ||
          (hasIn && noOut) ||
          (noIn && hasOut) ||
          (noIn && noOut)
        )
          return true;
      }
      //  else if (selectedOption === "Graveyard") {
      //   const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } = logCheck;
      //   if (
      //     late > 61 ||
      //     undertime > 61 ||
      //     (hasGraveIn && noGraveOut) ||
      //     (noGraveIn && hasGraveOut) ||
      //     (noGraveIn && noGraveOut)
      //   )
      //     return true;
      // }
      else if (selectedOption === "Graveyard") {
        const {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        } = logCheck;
        const result = [];

        if (
          late > 61 ||
          undertimeForDay_1 > 61 ||
          (hasAmIn && noPmOut) ||
          (noAmIn && hasPmOut) ||
          (noAmIn && noPmOut)
        ) {
          result.push("isAbsent");
        }
        if (
          latePmforDay_1 > 61 ||
          undertimeForDay_2 > 61 ||
          (hasPmIn && noAmOut) ||
          (noPmIn && hasAmOut) ||
          (noPmIn && noAmOut)
        ) {
          result.push("isNextDay");
        }

        return result.length > 0 ? result : false;
      } else {
        const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
          _graveyardLogStatus();
        if (
          late > 61 ||
          undertime > 61 ||
          (hasGraveIn && noGraveOut) ||
          (noGraveIn && hasGraveOut) ||
          (noGraveIn && noGraveOut)
        )
          return true;
        return false;
      }
    }

    // Absent: JO
    if (absentRules.isJO) {
      if (!isGraveyard && selectedOption !== "Graveyard") {
        if (
          (noIn && hasOut) ||
          (hasIn && noOut) ||
          (noIn && noOut)
          // totalLateUT > 240
        )
          return true;
      }
      // else if (selectedOption === "Graveyard") {
      //   const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } = logCheck;
      //   if (
      //     (hasGraveIn && noGraveOut) ||
      //     (noGraveIn && hasGraveOut) ||
      //     (noGraveIn && noGraveOut)
      //   )
      //     return true;
      // }
      else if (selectedOption === "Graveyard") {
        const {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        } = logCheck;

        console.log("Log", log);
        console.log("hasAmIn", hasAmIn);
        console.log("noPmOut", noPmOut);

        const result = [];

        if (
          (hasAmIn && noPmOut) ||
          (noAmIn && hasPmOut) ||
          (noAmIn && noPmOut)
        ) {
          result.push("isAbsent");
        }
        if (
          (hasPmIn && noAmOut) ||
          (noPmIn && hasAmOut) ||
          (noPmIn && noAmOut)
        ) {
          result.push("isNextDay");
        }

        return result.length > 0 ? result : false;
      } else {
        const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
          _graveyardLogStatus();
        if (
          (hasGraveIn && noGraveOut) ||
          (noGraveIn && hasGraveOut) ||
          (noGraveIn && noGraveOut)
        )
          return true;
        return false;
      }
    }

    // Half-day: Basic
    if (
      ["isThirdCase", "isSecondCase", "isSeventhCase"].includes(cases) &&
      type === "forHalfDay"
    ) {
      const isMatchSchedule =
        Array.isArray(schedPattern?.matchedSchedule) &&
        schedPattern.matchedSchedule.length > 0;

      //half-day non-graveyard
      if (isMatchSchedule && !isGraveyard && selectedOption !== "Graveyard") {
        return (
          (noIn && hasOut && undertime <= 120) ||
          (hasIn && noOut && late <= 180)
        );
      }
      //half-day graveyard
      if (isGraveyard) {
        const { hasGraveIn, hasGraveOut, noGraveIn, noGraveOut } =
          _graveyardLogStatus();
        if (
          (hasGraveIn && noGraveOut && late <= 180) ||
          (hasGraveOut && noGraveIn && undertime <= 120)
        )
          return true;
        return false;
      }
      if (selectedOption === "Graveyard") {
        const {
          hasAmIn,
          hasPmIn,
          hasPmOut,
          hasAmOut,
          noAmIn,
          noPmIn,
          noPmOut,
          noAmOut,
        } = logCheck;

        if (
          (hasAmIn && noPmOut && late <= 180) ||
          (hasPmOut && noAmIn && undertimeForDay_1 <= 120)
        ) {
          return "isHalfDayforDay_1";
        } else if (
          (hasPmIn && noAmOut && latePmforDay_1 <= 180) ||
          (noPmIn && hasAmOut && undertimeForDay_2 <= 120)
        ) {
          return "isHalfDayforDay_2";
        }
        return false;
      }

      // For regular schedules like 4,2-3,2, etc.
      return (
        (noIn && hasOut && undertime <= 120) || (hasIn && noOut && late <= 180)
      );
    }

    return false;
  };

  _getWorkingDaysList = (
    rangeStart,
    rangeEnd,
    schedPattern,
    groupLogsSched
  ) => {
    const start = new Date(rangeStart);
    const end = new Date(rangeEnd);
    const result = [];

    const formatDate = (date) => new Date(date).toISOString().split("T")[0];

    // Reusable checks
    const isWeekday = (date, schedPattern) => {
      if (!schedPattern?.selectedOption) return false;
      const dayName = date.toLocaleString("en-US", { weekday: "long" });
      const bool = schedPattern?.selectedOption.some(
        (sched) => sched.day === dayName
      );

      return bool;
    };

    const isInCycle = (date, schedPattern) => {
      if (!schedPattern?.matchedSchedule || !schedPattern?.startingDate)
        return false;

      const [_, work, off] = schedPattern.matchedSchedule.map(Number);
      const cycleLength = work + off;
      const startingDate = new Date(schedPattern?.startingDate);
      startingDate.setHours(0, 0, 0, 0);

      const daysFromStart = Math.floor(
        (date - startingDate) / (1000 * 60 * 60 * 24)
      );
      console.log("DATEE", date);
      console.log("daysFromStart", daysFromStart);
      console.log("startingDate", startingDate);

      const cycleDay =
        ((daysFromStart % cycleLength) + cycleLength) % cycleLength;
      return cycleDay < work;
    };

    const isInGraveyardList = (date, schedPattern) => {
      if (!schedPattern?.twoDayGraveyardMatchList) return false;
      const dayName = date.toLocaleString("en-US", { weekday: "long" });
      return schedPattern.twoDayGraveyardMatchList.some(
        ({ match }) => match[1] === dayName || match[2] === dayName
      );
    };

    const isInAltWorkingDays = (date, schedPattern) => {
      if (!schedPattern?.workingDaysAlt) return false;
      const dayName = date.toLocaleString("en-US", { weekday: "long" });
      return schedPattern.workingDaysAlt.includes(dayName);
    };

    const isWorkingDay = (date, schedPattern) => {
      if (schedPattern?.selectedOption) return isWeekday(date, schedPattern);
      if (schedPattern?.matchedSchedule && schedPattern?.startingDate)
        return isInCycle(date, schedPattern);
      if (schedPattern?.twoDayGraveyardMatchList)
        return isInGraveyardList(date, schedPattern);
      if (schedPattern?.workingDaysAlt)
        return isInAltWorkingDays(date, schedPattern);
      return false;
    };

    const getSchedForDate = (date) => {
      const target = formatDate(date);

      for (const rangeKey in groupLogsSched) {
        const [startStr, endStr] = rangeKey.split(" - ").map((s) => s.trim());

        if (target >= startStr && target <= endStr) {
          return groupLogsSched[rangeKey];
        }
      }
      return null;
    };

    const getScheduleForDate = (current, groupLogsSched) => {
      for (const range in groupLogsSched) {
        const [startStr, endStr] = range.split(" - ");
        const start = new Date(startStr);
        const end = new Date(endStr);

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        current.setHours(0, 0, 0, 0);

        if (current >= start && current <= end) {
          return groupLogsSched[range];
        }
      }

      return null; // not found
    };

    let current = new Date(start);
    while (current <= end) {
      // const schedPattern = getSchedForDate(current);
      const schedPattern = getScheduleForDate(current, groupLogsSched);

      console.log("schedPattern", schedPattern);

      if (schedPattern && isWorkingDay(current, schedPattern)) {
        result.push(current.toDateString());
      }
      current.setDate(current.getDate() + 1);
    }

    return result;
  };

  _getSuspensionOverlapMins = (
    suspensions,
    logDate,
    rangeStartMin,
    rangeEndMin
  ) => {
    const dayStart = new Date(logDate);
    let totalOverlap = 0;

    for (const suspension of suspensions) {
      const from = new Date(suspension.dateFrom);
      const to = new Date(suspension.dateTo);

      if (from.toDateString() !== dayStart.toDateString()) continue;

      const suspensionStartMin = from.getHours() * 60 + from.getMinutes();
      const suspensionEndMin = to.getHours() * 60 + to.getMinutes();

      const overlapStart = Math.max(rangeStartMin, suspensionStartMin);
      const overlapEnd = Math.min(rangeEndMin, suspensionEndMin);

      if (overlapStart < overlapEnd) {
        totalOverlap += overlapEnd - overlapStart;
      }
    }

    return totalOverlap;
  };

  _calcLate = (timeInPmMin, schedTimeInPmMin) => {
    const MINUTES_IN_DAY = 1440;
    const HALF_DAY = MINUTES_IN_DAY / 2;
    if (timeInPmMin === 0) return 0;
    let diff = timeInPmMin - schedTimeInPmMin;

    if (diff < -HALF_DAY) diff += MINUTES_IN_DAY;

    return Math.max(diff, 0);
  };

  _to24HourPM(timeStr, isPM = false) {
    let [hours, minutes] = timeStr.split(":").map(Number);

    if (isPM && hours !== 12) {
      hours += 12;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }
  parseSchedPatternFromLog = (log) => {
    const schedule = log?.schedule?.scheduleArray ?? [];
    const scheduleName = schedule[0]?.day || "";
    const selectedOption = log?.schedule?.selectedOption || "";

    const graveyardMatch = scheduleName.match(
      /^Graveyard (\d+)days Working, (\d+)days off$/
    );
    const regularMatch = scheduleName.match(
      /^Regular (\d+)days Working, (\d+)days off$/
    );
    const plainCycleMatch = scheduleName.match(
      /^(\d+)days Working, (\d+)days off$/
    );

    const alternateMWFMatch = selectedOption === "Alternate (MWF)";
    const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
    const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

    const workingDaysAlt = alternateMWFMatch
      ? ["Monday", "Wednesday", "Friday"]
      : alternateTTHSMatch
      ? ["Tuesday", "Thursday", "Saturday"]
      : [];

    const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;

    const twoDayGraveyardMatchList = [];
    if (selectedOption === "Graveyard") {
      for (const sched of schedule) {
        const name = sched?.day || "";
        const match = name.match(/^(\w+) - (\w+)$/);
        if (match) {
          twoDayGraveyardMatchList.push({
            match,
            timein: sched.timein,
            timeout: sched.timeout,
            earliestTimeOut: sched.earliestTimeOut,
            lateTimeIn: sched.lateTimeIn,
          });
        }
      }
    }

    if (matchedSchedule) return { matchedSchedule };
    if (twoDayGraveyardMatchList.length > 0)
      return { twoDayGraveyardMatchList };
    if (isAlternateSchedule) return { workingDaysAlt };
    return { selectedOption: schedule };
  };
}

export default FormPayrollPresenter;
